"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapToZipLineItems = exports.getPaymentAuthorizeData = exports.getFullAuthorizeData = exports.fetchUserInfo = exports.fetchAddressInfo = exports.constructPostValidateResponse = void 0;
var _commonUtils = require("../../../utils/commonUtils");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var getPaymentAuthorizeData = function getPaymentAuthorizeData(paymentMethod, result) {
  return {
    'paymentMethod': paymentMethod,
    'payload': {
      'cardNumber': result.card.number,
      'cardType': (0, _commonUtils.getFullCardNumberType)(result.card.number),
      'cardValidationNumber': result.card.cvc,
      'expirationMonth': result.card.expirationMonth.toString(),
      'expirationYear': result.card.expirationYear.toString(),
      // customer Info is not leveraged by Payment Plus currently, this is the future scope of pp.
      'customerInfo': {
        'firstName': result.customer.firstName,
        'lastName': result.customer.lastName,
        'addressLine1': result.customer.address1,
        'addressLine2': (0, _commonUtils.isEmptyString)(result.customer.address2) ? undefined : result.customer.address2,
        'city': result.customer.city,
        'stateOrProvince': result.customer.state,
        'postalCode': result.customer.postalCode,
        'countryCode': result.customer.country
      }
    }
  };
};
exports.getPaymentAuthorizeData = getPaymentAuthorizeData;
var getFullAuthorizeData = function getFullAuthorizeData(inputCustomData, cartAmount, userInfo, billingAndShippingInfo, payment) {
  var billingAddress = billingAndShippingInfo.billingAddress;
  var obj = {
    caseId: inputCustomData.caseId,
    cartAmount: cartAmount,
    currencyCode: inputCustomData.cart.currencyCode,
    user: userInfo,
    billingAddress: billingAddress,
    payment: payment
  };
  Object.keys(obj).forEach(function (key) {
    return obj[key] == undefined && delete obj[key];
  });
  return obj;
};
exports.getFullAuthorizeData = getFullAuthorizeData;
var fetchAddressInfo = function fetchAddressInfo(user) {
  return {
    billingAddress: {
      'addressType': 'BILLING',
      firstName: user.cardholder.firstName,
      lastName: user.cardholder.lastName,
      addressLine1: user.cardholder.address1,
      addressLine2: (0, _commonUtils.isEmptyString)(user.cardholder.address2) ? undefined : user.cardholder.address2,
      city: user.cardholder.city,
      stateOrProvince: user.cardholder.state,
      postalCode: user.cardholder.postalCode,
      countryCode: user.cardholder.country,
      emailAddress: user.customer.email,
      phoneNumber: user.customer.phoneNumber
    }
  };
};
exports.fetchAddressInfo = fetchAddressInfo;
var fetchUserInfo = function fetchUserInfo(user) {
  return {
    firstName: user.customer.firstName,
    lastName: user.customer.lastName,
    emailAddress: user.customer.email,
    phoneNumber: user.customer.phoneNumber
  };
};
exports.fetchUserInfo = fetchUserInfo;
var constructPostValidateResponse = function constructPostValidateResponse(customFunctions, billingAndShippingInfo, paymentMethod, user) {
  return customFunctions['postValidate'] ? customFunctions['postValidate']({
    'paymentData': {
      paymentMethod: paymentMethod
    },
    'otherInformation': billingAndShippingInfo.billingAddress,
    'userInformation': fetchUserInfo(user)
  }) : {};
};
exports.constructPostValidateResponse = constructPostValidateResponse;
var mapToZipLineItems = function mapToZipLineItems(cartItems) {
  var mappedLineItems = [];
  if (!cartItems) {
    return mappedLineItems;
  }
  var mapper = {
    'brand': 'name',
    'description': 'description',
    'unitPrice': 'price',
    'quantity': 'quantity'
  };
  var _iterator = _createForOfIteratorHelper(cartItems),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var cartItem = _step.value;
      var lineItem = (0, _commonUtils.mapObjectProperties)(cartItem, mapper);
      if (!lineItem['name']) {
        lineItem['name'] = cartItem['description'];
      }
      mappedLineItems.push(lineItem);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return mappedLineItems;
};
exports.mapToZipLineItems = mapToZipLineItems;